import { FFContextProvider } from '@harnessio/ff-react-client-sdk';
import { PropsWithChildren } from 'react';

import { useAuth } from '@verantos-dev/core-auth';

const bypassAuthForLocalDevelopment = import.meta.env.VITE_BYPASS_NETWORK_CONNECTION === 'true';
const clientSideID = import.meta.env.VITE_HARNESS_CLIENT_SDK_API_KEY;

export const HarnessFFProvider = ({ children }: PropsWithChildren) => {
  const {
    user: { email, firstName, lastName },
  } = useAuth();
  const sanitizedEmail = email?.replace(/[^a-zA-Z0-9 .@_-]/g, '.');
  const sanitizedFirstName = firstName?.replace(/[^a-zA-Z0-9À-ÿ .@_-]/g, '.');
  const sanitizedLastName = lastName?.replace(/[^a-zA-Z0-9À-ÿ .@_-]/g, '.');

  if (bypassAuthForLocalDevelopment) {
    console.warn(
      'Bypassing HarnessFFProvider for local development because VITE_BYPASS_NETWORK_CONNECTION is set to true.'
    );
    return children;
  }

  if (!clientSideID) {
    throw new Error('Client Side ID is missing');
  }

  return (
    <FFContextProvider
      apiKey={clientSideID}
      target={{
        anonymous: !sanitizedEmail,
        name:
          sanitizedFirstName && sanitizedLastName
            ? `${sanitizedFirstName} ${sanitizedLastName}`
            : undefined,
        identifier: sanitizedEmail || 'anonymous',
      }}
      options={{
        cache: {
          ttl: 5 * 60 * 1000,
        },
      }}
    >
      {children}
    </FFContextProvider>
  );
};
